import * as React from 'react';
import { ILanguageToggleViewProps } from './language-toggle';

export default (props: ILanguageToggleViewProps) => {
    const {
        context: { request },
        config
    } = props;

    const requestUrl = request.url.requestUrl;
    const sitePath = request.sitePath;
    const requestPathname = requestUrl.pathname;
    const targetRoutePrefix = config.targetRoutePrefix ?? '/fr';

    const [toggleUrl, toggleLbl] = React.useMemo(() => {
        if (!targetRoutePrefix) {
            return [null, null];
        }

        if (sitePath?.toLocaleLowerCase() === targetRoutePrefix.toLocaleLowerCase()) {
            const pathname = requestPathname.substring(sitePath.length) || '/';
            return [new URL(pathname.replace('//', '/'), requestUrl).toString(), config.sourceLanguageLabel];
        } else {
            const pathname =
                sitePath && requestPathname.toLocaleLowerCase().startsWith(sitePath.toLocaleLowerCase())
                    ? `${targetRoutePrefix}${requestPathname.substr(sitePath.length)}`
                    : `${targetRoutePrefix}${requestPathname}`;
            return [new URL(pathname.replace('//', '/'), requestUrl).toString(), config.targetLanguageLabel];
        }
    }, [requestPathname, sitePath, targetRoutePrefix, requestUrl, config]);

    if (!toggleUrl || !toggleLbl) {
        return null;
    }

    return (
        <div className='hei-language-toggle'>
            <a href={toggleUrl} title={toggleLbl}>
                {toggleLbl}
            </a>
        </div>
    );
};
